module.exports = __webpack_public_path__ + "img/sankaku_83_blue.d680b1a3.png";